"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangeRequestConnection = void 0;
var dataConverter_1 = require("../../utils/dataConverter");
var ChangeRequestConnection = /** @class */ (function () {
    function ChangeRequestConnection(data, connectionOfEntityIri) {
        Object.assign(this, __assign(__assign({}, data), { type: data['@type'] }));
        if (data.changeRequest) {
            this.changeRequest = dataConverter_1.createEntityChangeRequestFromData(data.changeRequest);
        }
        var connectionOfEntityId = parseInt(connectionOfEntityIri.split('/').pop(), 10);
        // since the entities can be on either the left or the right side, have to define them a consistent way
        // therefore it is easier to handle the connection and the connected entity
        // the fromEntityPosition always contains the entity that the connection was requested for (aka connectionOfEntityIri)
        // and the toEntity contains the entity that was connected
        this.fromEntityPosition = connectionOfEntityId === data.left.id ? 'left' : 'right';
        this.toEntityPosition = 'left' === this.fromEntityPosition ? 'right' : 'left';
        this.fromEntity = dataConverter_1.createEntityFromData(data[this.fromEntityPosition]);
        this.toEntity = dataConverter_1.createEntityFromData(data[this.toEntityPosition]);
    }
    ChangeRequestConnection.prototype.getVideoSegment = function () {
        var _this = this;
        if (!this.videoSegmentId) {
            return null;
        }
        var segments = this.fromEntity.segments || this.toEntity.segments;
        if (!segments) {
            return null;
        }
        return segments.find(function (item) { return _this.videoSegmentId === item.id; });
    };
    ChangeRequestConnection.prototype.isDescriptionSame = function () {
        return this.leftDescription === this.rightDescription;
    };
    return ChangeRequestConnection;
}());
exports.ChangeRequestConnection = ChangeRequestConnection;
